import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import '../../website.css';

const Layout = () => {
    const [isLightMode, setIsLightMode] = useState(false);

    return (
        <div className={`product-website-root ${isLightMode ? 'light-mode' : ''}`}>
            <Header isLightMode={isLightMode} setIsLightMode={setIsLightMode} />
            <main className="main-content">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default Layout;

